import { useScopedOmniFilter } from 'api/use-scoped-omni-filter';

/** The global filter's selection, as the grants routes' query params. */
export type GrantsScope = Record<string, string>;

export function useGrantsScope(): GrantsScope {
  const omniFilterState = useScopedOmniFilter();
  const scope: GrantsScope = {};
  for (const key of [
    'integrationIds',
    'integrationGroupIds',
    'assetGroupIds',
    'environmentIds',
  ] as const) {
    const ids = omniFilterState[key];
    if (ids?.length) {
      scope[key] = ids.join(',');
    }
  }
  return scope;
}
